import { GET_QUOTE_BY_ID } from './getQuoteById';
import { QUOTE_CALC_BY_ID } from './quoteCalcById';
import { GET_QUOTE_BY_VO_ID } from './getQuoteByVOId';
import { QUOTE_CALC_PREVIEW } from './quoteCalcPreview';
import { QUOTE_CHANGELOG_LIST } from './quoteChangelogList';
import { QUOTE_CHANGELOG_BY_ID } from './quoteChangelogById';
import { CREATE_OR_UPDATE_QUOTE } from './createOrUpdateQuote';

export const quoteAPI = {
  getQuote: GET_QUOTE_BY_VO_ID,
  getQuoteById: GET_QUOTE_BY_ID,
  getQuoteCalcById: QUOTE_CALC_BY_ID,
  upsertQuote: CREATE_OR_UPDATE_QUOTE,
  getQuoteCalcPreview: QUOTE_CALC_PREVIEW,

  getQuoteChangelogById: QUOTE_CHANGELOG_BY_ID,
  getQuoteChangelogList: QUOTE_CHANGELOG_LIST,
};
